"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function PasswordRevealIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M18.587,6.514l1.855-3.15L18.977,2.5,17.113,5.667a11.729,11.729,0,0,0-4.577-1.146V.485h-1.7V4.564a11.719,11.719,0,0,0-4.43,1.353L4.395,2.5,2.93,3.364,4.971,6.831A11.882,11.882,0,0,0,1,12a11.817,11.817,0,0,0,22,0A11.881,11.881,0,0,0,18.587,6.514ZM11.964,17.726A5.726,5.726,0,1,1,17.691,12,5.734,5.734,0,0,1,11.964,17.726Z" }),
        react_1.default.createElement("path", { d: "M11.964,9.027A2.973,2.973,0,1,0,14.937,12,2.977,2.977,0,0,0,11.964,9.027Zm0,4.246A1.273,1.273,0,1,1,13.237,12,1.274,1.274,0,0,1,11.964,13.273Z" })));
}
exports.default = PasswordRevealIcon;
